export const ERROR_ADD_ITEM = 'ERROR_ADD_ITEM';
export const ERROR_DELETE_ALL = 'ERROR_DELETE_ALL';
export const ERROR_DELETE_ITEM = 'ERROR_DELETE_ITEM';
export const ERROR_SET_PARAM = 'ERROR_SET_PARAM';
export const ERROR_RESET_STATE = 'ERROR_RESET_STATE';
export const ERROR_DELETE_FLASH_ITEM = 'ERROR_DELETE_FLASH_ITEM';
